
import { Vue, Component } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { IAPPSTATE } from '@/store/state.d';

@Component
export default class MenuTrigger extends Vue {
  @State app!: IAPPSTATE

  @Mutation('app/SET_APP_MENU_STATUS') setMenuStatus!: Function
}
